import { render } from "./DashboardOverview.vue?vue&type=template&id=113948f6&scoped=true"
import script from "./DashboardOverview.vue?vue&type=script&lang=js"
export * from "./DashboardOverview.vue?vue&type=script&lang=js"

import "./DashboardOverview.vue?vue&type=style&index=0&id=113948f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113948f6"]])

export default __exports__